import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authService } from '../services/auth.service';
import { useToast } from '../hooks/useToast';
import Button from '../components/common/Button';

const CheckYourEmail: React.FC = () => {
  const [resending, setResending] = useState(false);
  const { showToast } = useToast();

  const handleResend = async () => {
    setResending(true);
    try {
      await authService.resendVerification();
      showToast('success', 'Verification email sent — check your inbox.');
    } catch {
      showToast('error', 'Could not resend verification email. Please try again shortly.');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-4 text-center">
        <h2 className="text-2xl font-bold text-gray-900">Check your email</h2>
        <p className="text-sm text-gray-600">
          We&apos;ve sent a verification link to your email address. Click it to verify your
          account — you can continue now, but you&apos;ll need to verify before uploading
          models or creating embeds.
        </p>
        <Button onClick={handleResend} loading={resending} disabled={resending}>
          Resend verification email
        </Button>
        <div>
          <Link to="/dashboard" className="font-medium text-primary-600 hover:text-primary-500">
            Continue to dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CheckYourEmail;
